import { IAutocompleteBaseOption } from '../types'

/**
 * Base function to abstract or use declaratively
 * @example createOption({ id: '1', text: 'Jane', groupIndex 2 })
 */
export const createOption = (props: IAutocompleteBaseOption): IAutocompleteBaseOption => ({
  ...props,
})

export const createAvatarOption = (
  props: Omit<IAutocompleteBaseOption, 'optionType'>
): IAutocompleteBaseOption => ({
  optionType: 'withAvatar',
  ...props,
})

export const createIconOption = (
  props: Omit<IAutocompleteBaseOption, 'optionType'>
): IAutocompleteBaseOption => ({
  optionType: 'withIcon',
  ...props,
})

interface ICreateAddOptionProps
  extends Pick<IAutocompleteBaseOption, 'iconName' | 'optionType' | 'dividerBefore' | 'groupName'> {
  groupIndex?: IAutocompleteBaseOption['groupIndex']
  inputValue?: IAutocompleteBaseOption['inputValue']
  text?: IAutocompleteBaseOption['text']
  onClick: IAutocompleteBaseOption['onClick']
}

/**
 * Generates "Add [userName]" option for <AutocompleteBase />
 * @exampel createAddOption({ inputValue: 'Jane', groupIndex: 1 })
 */
export const createAddOption = (props: ICreateAddOptionProps): IAutocompleteBaseOption => {
  const {
    dividerBefore = false,
    groupIndex = 0,
    groupName = '',
    iconName = 'PlusIcon',
    inputValue = '',
    optionType = 'withIcon',
    text: textProp,
  } = props || {}
  const text = textProp || `Add "${inputValue}"`

  return createOption({
    id: 'add-option',
    inputValue,
    text,
    optionType,
    dividerBefore,
    groupName,
    iconName,
    groupIndex,
    ...props,
  })
}
